<button type="{{ type }}" class="btn btn-{{ loading ? 'default' : color }} {{ block ? 'btn-block' : '' }} {{ size ? 'btn-' + size : '' }} {{ simple ? 'btn-simple' : '' }} {{ fill ? 'btn-fill' : '' }} {{ small ? 'btn-sm' : '' }}" [disabled]="disabled || loading">
    <ng-container *ngIf="icon || loading">
        <i class="fa {{ loading ? 'fa-spin fa-spinner' : 'fa-' + icon }}"></i>&nbsp;
    </ng-container>
    <ng-content></ng-content>
</button>
